module.exports = __webpack_public_path__ + "img/Shelby.b4cabee2.png";